import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=1c80f48e"
import script from "./accounts.js?vue&type=script&lang=js&external"
export * from "./accounts.js?vue&type=script&lang=js&external"
import style0 from "./accounts.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports